// Color-theme helpers — copy of frontend/src/utils/colorThemes.js so the
// admin order-template editor applies the same hue rotation the customer saw.
// Keep the two files in sync.

export const COLOR_THEMES = [
  { id: 'orig',  name: 'Original', targetHue: null },
  { id: 'blue',  name: 'Blue',     targetHue: 220 },
  { id: 'pink',  name: 'Pink',     targetHue: 320 },
  { id: 'green', name: 'Green',    targetHue: 120 },
];

// Convert a #RRGGBB hex to HSL hue in degrees. Returns null for invalid input.
export function hexToHue(hex) {
  const m = /^#?([0-9a-fA-F]{6})$/.exec(hex || '');
  if (!m) return null;
  const r = parseInt(m[1].slice(0, 2), 16) / 255;
  const g = parseInt(m[1].slice(2, 4), 16) / 255;
  const b = parseInt(m[1].slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  if (max === min) return 0;
  const d = max - min;
  let h;
  if (max === r) h = ((g - b) / d + (g < b ? 6 : 0));
  else if (max === g) h = ((b - r) / d + 2);
  else h = ((r - g) / d + 4);
  return (h * 60 + 360) % 360;
}

// CSS filter string for a given (sourceHue, targetHue). 'none' when no rotation.
export function filterFor(sourceHue, targetHue) {
  if (targetHue == null || sourceHue == null) return 'none';
  const delta = ((targetHue - sourceHue) % 360 + 360) % 360;
  return delta === 0 ? 'none' : `hue-rotate(${delta}deg)`;
}

// Visible swatch colour for each button.
export function swatchColorFor(theme, baseColorHex) {
  if (theme.targetHue == null) return baseColorHex || '#a8853f';
  return `hsl(${theme.targetHue}, 60%, 50%)`;
}

// Should the swatch row render? Only when a valid base colour is set.
export function themesEnabledFor(baseColorHex) {
  return hexToHue(baseColorHex) != null;
}
